<div id="aboutUsDialog">
    <div mat-dialog-title>
        <img [ngSrc]="'/assets/images/new_prism_logo.png'" class="logo" alt="ADS PRISM" height="45" width="150" />
        <div class="mediumHeaderText">{{ 'ABOUT_US.HEADER' | translate }}</div>
    </div>
    <div mat-dialog-content>
        <div class="buildDetails">
            <app-loader [isLoading]="buildLoadingState"></app-loader>
            <div class="eachContent">
                <div class="buildNumerText">{{ buildNumbers?.build }}</div>
                <div class="buildTypeText">{{ 'ABOUT_US.API_BUILD' | translate }}</div>
            </div>
            <div class="eachContent">
                <div class="buildNumerText">{{ buildNumbers?.ui }}</div>
                <div class="buildTypeText">{{ 'ABOUT_US.UI_BUILD' | translate }}</div>
            </div>
        </div>
        <div class="terms">
            <span>
                {{ 'ABOUT_US.VIEW' | translate }}
                <a href="https://www.adsenv.com/prismuseragreement/" target="_blank">{{
                    'COMMON.USER_AGREEMENT' | translate
                }}</a>
            </span>
            <span>
                {{ 'ABOUT_US.VIEW' | translate }}
                <a href="https://www.adsenv.com/legal-notices#privacy" target="_blank">{{
                    'COMMON.PRIVACY_POLICY' | translate
                }}</a>
            </span>
            <br /><br />
            <span> {{ 'ABOUT_US.REGION' | translate }}: {{ buildNumbers?.region }} </span>
            <span> {{ 'ABOUT_US.NODE' | translate }}: {{ buildNumbers?.node }} </span>
        </div>
    </div>
    <div mat-dialog-actions>
        <div class="app-flex-filler"></div>
        <div class="auto-margin">
            <button mat-button (click)="emitAboutUs()">{{ 'COMMON.CLOSE' | translate }}</button>
        </div>
    </div>
</div>
